import imgStep1 from "../../images/onboarding/RallyQuest/1.png";
import imgStep2 from "../../images/onboarding/RallyQuest/2.png";
import imgStep3 from "../../images/onboarding/RallyQuest/3.png";
import imgMap from "../../images/onboarding/Waitlist/map.png";

const preloadImage = (src) => {
  const img = new Image();
  img.src = src;
};

[imgStep1, imgStep2, imgStep3].forEach(preloadImage);

export const WAITLIST_DATA = {
  type: "SINGLE",
  title: "You’re In",
  subTitle: "What's Next",
  icon: "🎉",
  image: imgMap,
  description:
    "We are finalising eligible F&B spots.\nStay tuned to our Whatsapp updates!",
  buttonText: "Got it",
};

export const ONBOARDING_STEPS = {
  type: "CAROUSEL",
  steps: [
    {
      id: 1,
      subTitle: "What's Next",
      title: "Go Homepage",
      description: (
        <span>
          Tap <span className="font-bold">Rally Logo</span> to Homepage
        </span>
      ),
      image: imgStep1,
    },
    {
      id: 2,
      subTitle: "What's Next",
      title: "See More Quests",
      description: (
        <span>
          View more quests using the <span className="font-bold">arrow</span>{" "}
          icon
        </span>
      ),
      image: imgStep2,
    },
    {
      id: 3,
      subTitle: "What's Next",
      title: "Keep Receipts",
      description: (
        <span>
          Dine as usual. <br />
          Start quest and
          <span className="font-bold"> upload your receipt.</span>
        </span>
      ),

      image: imgStep3,
    },
  ],
};
